import React, { useEffect, useState } from 'react';
import RoleService from "./service/RoleService";
import { Dropdown } from "primereact/dropdown";
const AppFooter = (props) => {
    const [lojaSelecionada, setLojaSelecionada] = useState();
    const [lojas, setLojas] = useState([]);

    useEffect(() => {
        const userProfile = JSON.parse(localStorage.getItem('profile'));

        let _lojas = [...lojas];

        if (userProfile) {
            _lojas.push(...userProfile.companies);
            setLojas(_lojas);
        }

        if (localStorage.getItem('lojaSelecionada')) {

            try {
                setLojaSelecionada(JSON.parse(localStorage.getItem('lojaSelecionada')));
            } catch (e) {

            }
        } else {
            let lojaDefault = userProfile ? userProfile.companies[0] : [];
            if (lojaDefault) {
                setLojaSelecionada(lojaDefault);
                localStorage.setItem('lojaSelecionada', JSON.stringify(lojaDefault));
            }
        }
    }, []);

    /* useEffect(() => {
        lojaService.getLojas().then(data => {
            let _lojas = [...lojas];
            _lojas.push(...data.data);
            setLojas(_lojas);
            if(localStorage.getItem('lojaSelecionada')){
                try {
                    setLojaSelecionada(JSON.parse(localStorage.getItem('lojaSelecionada')));
                }catch (e){

                }
            }else{
                let lojaDefault = _lojas.find(l => l.padrao)
                if(lojaDefault){
                    setLojaSelecionada(lojaDefault);
                    localStorage.setItem('lojaSelecionada', JSON.stringify(lojaDefault));
                }
            }
        });
    }, []); */

    const lojaSelecionadaChange = (e) => {
        setLojaSelecionada(e.value);
        localStorage.setItem('lojaSelecionada', JSON.stringify(e.value));
        window.location.reload();
    }

    return (
        <div className="layout-footer">
            <div className="footer-logo-container">
                {/* <span style={{ marginRight: 15 }} className="app-name">{localStorage.getItem('nomeEmpresa')}</span> - */}

                <span style={{ marginRight: 15 }} className="app-name">{lojaSelecionada != null ? lojaSelecionada.name : ""}</span> -

                {(RoleService.isWhiteLabel() || RoleService.isColaborador()) && (
                    <Dropdown style={{ marginLeft: 20 }} value={lojaSelecionada} onChange={(e) => lojaSelecionadaChange(e)} options={lojas}
                        optionLabel="name"
                        placeholder="Selecione uma loja" className="w-full md:w-14rem" />
                )}

            </div>
            <span className="copyright">&#169; Your Organization - 2021</span>
        </div>

    )
}

export default AppFooter;
